<template>
  <Spinner :enable="spinner.enable"></Spinner>
  <slot></slot>
  <teleport to="#publicPop">
    <AppModalPopup popupId="guideModal" class="bottom" v-show="false" @update:closeCallBack="loginPageCheck">
      <template #header>
        <h1 class="t-center">실손24 청구서비스 이용안내</h1>
      </template>
      <template #default>
        <div class="section">

          <p class="txt-pop t-center">
            의료정보의 전송 및 보험금 청구에 대한 <br/>모든 책임은 소비자에게 있으며, <br/>의료기관은 이에 대한 일체의
            책임을 지지 않습니다.
          </p>
        </div>
        <!-- 해당부분 체크박스 컴포넌트로 만들기 -->
        <div class="mt-24">
          <label for="chk1" class="checkbox">
            <input type="checkbox" id="chk1" name="chk1" @change="setCookie($event)"/><i
              aria-hidden="true" class="lbl"></i>
            <span>하루동안 보지 않기</span>
          </label>
        </div>
      </template>

      <template #footer>
        <div class="flex">
          <button type="button" class="btn btn-primary ui-pop-close" @click="closeClaimInfo">확인</button>
        </div>
      </template>
    </AppModalPopup>
    <select-certificate-popup v-show="false" popup-id="certificatePop2"></select-certificate-popup>
    <Loading v-show="false" :enable="loading.enable"></Loading>
    <PageMoveLoading v-show="false" :enable="pageLoading.enable"></PageMoveLoading>
    <Alert v-if="alert.show"></Alert>
    <LogoutPop v-show="false" popupId="logoutPop" :time="setTime"></LogoutPop>
    <div id="oacxDiv"></div>
  </teleport>
</template>

<script setup>
import Loading from "@/components/atoms/Loading.vue";
import Spinner from "@/components/atoms/Spinner.vue";
import {computed, nextTick, onMounted, provide, reactive, ref} from "vue";
import {togglePop} from "@/utils/commonUi";
import Alert from "@/components/atoms/Alert.vue";
import {cloneDeep} from "lodash-es";
import {useInject} from "@/utils/compossable/$component";
import AppModalPopup from "@/components/atoms/AppModalPopup.vue";
import {useRoute, useRouter} from "vue-router";
import {useMemberStore} from "@/services/store/memberStore";
import {useClaimStore} from "@/services/store/claimStore";
import commonJs from "@/plugins/commonJs";
import SelectCertificatePopup from "@/components/molecules/SelectCertificatePopup.vue";
import PageMoveLoading from "@/components/molecules/PageMoveLoading.vue";
import commonCode from "@/services/api/commonCode";
import {jwtDecode} from "jwt-decode";
import LogoutPop from "@/ui/LogoutPop.vue";

const spinner = ref({enable: false});
const loading = ref({enable: false});
const pageLoading = ref({enable: false});
const remainingTime = ref(0);

//alert open
const fnOpen = (msg) => {
  alert.show = true
  alert.message = msg;
}

//alertObj 초기화
const fnReset = () => {
  //alert close 시 0.5초 뒤에 닫힘 그래서 초기화도 0.5초 뒤에 이뤄지게 설정
  setTimeout(() => {
    Object.assign(alert, cloneDeep(baseObj));
  }, 500);
}

let timer = null;

const setTimer = async () => {
  const tokenData = JSON.parse(sessionStorage.getItem('token')); //토큰값
  await nextTick(async () => {
    if (tokenData) {
      const serverTime = await commonCode.getTokenTime(); //서버 현재시간 조회 로컬과 서버시간이 맞지 않아서 서버현재시간에 맞춤
      const decode = jwtDecode(tokenData.refToken); //토큰값 jwt-decode
      let expTime = decode.exp; //토큰 만료기간
      remainingTime.value = expTime - Math.floor(serverTime / 1000) //토큰 남은시간
      // remainingTime.value = 10 //토큰 남은시간
      delTimer() //setInterval 초기화
      timer = setInterval(async () => {
        remainingTime.value--
        if (remainingTime.value <= 0) {
          await sessionStorage.clear();
          await memberStore.init();
          await router.push({name: 'Main'});
          delTimer();
        } else if (remainingTime.value <= 180) {
          if (!memberStore.member.tokenTimeCheck) {
            togglePop('logoutPop', true);
            memberStore.member.tokenTimeCheck = true
          }
        }
      }, 1000)
    }
  })
}

//타이머 삭제
const delTimer = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
    togglePop('logoutPop', false);
  }
}

//alert 기본 값
const baseObj = {
  show: false,
  useHtml: false,
  id: "alertPop",
  message: '',
  btnObj: {
    confirm: '확인',
    cancel: '취소',
    btnType: 'singleButton'
  },
  fn: {
    fnSelect: null,
    fnClose: null,
    fnOpen,
    fnReset
  },
}

//alert 값
const alert = reactive(cloneDeep(baseObj));

const $component = {
  spinner: spinner,
  loading: loading,
  alert: alert,
  simpleAlert: fnOpen,
  pageLoading: pageLoading,
  setTimer: setTimer,
  delTimer: delTimer,
}

provide('$component', $component);

useInject($component);

const router = useRouter();
const route = useRoute();
const memberStore = useMemberStore();
const claimStore = useClaimStore();
let claimType = ''

const closeClaimInfo = () => {
  togglePop('guideModal', false);

  if (memberStore.member.loginMethodType === 'pwd' || memberStore.member.loginMethodType === 'sns') {
    memberStore.member.noticeCheck = true;
    togglePop('certificatePop2', true);
  } else {
    memberStore.member.noticeCheck = true;
    if (!memberStore.member.certCheck) {
      togglePop('certificatePop2', true);
    } else {
      /**
       * 실손청구 최초진입 판단 기준
       * 1.claimType null
       * 2.진입 url 값이 information 또는 selectClaim
       *   - selectClaim: 메인 > 실손청구
       *   - information: 보험계약정보입력 > 실손청구
       */
      claimType = claimStore.claim.claimType;
      if (commonJs.isEmpty(claimType) && memberStore.member.noticeTo === 'selectClaim' || memberStore.member.noticeTo === 'information') {
        router.push({name: 'selectClaim'});
      } else {
        router.push({name: memberStore.member.noticeTo});
      }
    }
  }
}

const setCallback = () => {
  claimType = claimStore.claim.claimType;
  if (commonJs.isEmpty(claimType) && memberStore.member.noticeTo === 'selectClaim' || memberStore.member.noticeTo === 'information') {
    router.push({name: 'selectClaim'});
  } else {
    router.push({name: memberStore.member.noticeTo});
    memberStore.member.noticeTo = "";
  }
  memberStore.member.certCheck = true;
}

provide('setCallback', setCallback);

const setCookie = (event) => {
  if (event.target.checked) {
    memberStore.setNoticeCookie();
  } else {
    memberStore.setNoticeCookie(true)
  }
}

const loginPageCheck = () => {
  claimStore.init();
  if (route.path.includes('login')) {
    router.replace({name: 'Main'});
  }
}

const setTime = computed(() => {
  const m = Math.floor(remainingTime.value / 60)
  const s = String(remainingTime.value % 60).padStart(2, '0')
  return `${m}:${s}`
})

onMounted(() => {
  setTimer()
})
</script>
